import type { VanityUrl } from '~/contracts';

export function formatKeyWordAndLocation(vanityUrl: VanityUrl): string {
  const location = vanityUrl.location ? `in ${vanityUrl.location}` : '';

  return `Used ${vanityUrl.keyword} ${location}`;
}
